module.exports = __webpack_public_path__ + "fe4f00f720e2553b2b09635aba4378d2.svg";